import { Lightbulb, MapPin, Ruler } from "@phosphor-icons/react";
import { PITCHES } from "../data/mockData";

const PITCH_BG =
  "https://static.prod-images.emergentagent.com/jobs/784dbb52-c333-452b-9dc0-e74e42a3174e/images/fb40e1d0fda5caf5dd96d427aee559cc4e5fa6497912593e3ee1f432d1b0c501.png";

const statusClass = (status) =>
  status === "Åben"
    ? "bg-brand/15 text-brand border-brand/40"
    : "bg-yellow-500/10 text-yellow-400 border-yellow-500/40";

export const Baneoversigt = () => {
  return (
    <section
      id="baneoversigt"
      data-testid="baneoversigt-section"
      className="relative border-t border-neutral-900 bg-[#0A0A0A] py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="section-eyebrow">01 · Anlæg</span>
            <h2 className="mt-5 font-heading text-5xl uppercase leading-none tracking-tight text-white sm:text-6xl lg:text-7xl">
              Baneoversigt
            </h2>
            <p className="mt-4 max-w-2xl font-body text-neutral-400">
              Seks baner i Taastrup Idrætspark. Alt fra opvisningsbanen til 5-mands
              kunstgræs til de mindste – der er plads til alle.
            </p>
          </div>
          <div className="mono-label hidden gap-6 md:flex">
            <div>
              <div className="text-neutral-500">Total baner</div>
              <div className="mt-1 font-heading text-3xl text-white">06</div>
            </div>
            <div>
              <div className="text-neutral-500">Kunstgræs</div>
              <div className="mt-1 font-heading text-3xl text-brand">02</div>
            </div>
            <div>
              <div className="text-neutral-500">Lys</div>
              <div className="mt-1 font-heading text-3xl text-white">05</div>
            </div>
          </div>
        </div>

        {/* Map-like visual + grid */}
        <div className="mt-12 grid gap-6 lg:grid-cols-5">
          <div
            data-testid="baneoversigt-map"
            className="relative hairline order-last overflow-hidden lg:order-first lg:col-span-2 lg:row-span-2"
          >
            <img
              src={PITCH_BG}
              alt="Top-down visning af Taastrup FC's baner"
              className="h-full min-h-[360px] w-full object-cover opacity-80"
            />
            <div className="absolute inset-0 bg-gradient-to-br from-black/30 via-transparent to-black/60" />
            <div className="absolute left-4 top-4">
              <span className="mono-label bg-black/70 px-3 py-1 text-brand">
                Taastrup Idrætspark
              </span>
            </div>
            <div className="absolute bottom-4 right-4">
              <a
                href="https://maps.google.com/?q=Taastrup+Idr%C3%A6tspark"
                target="_blank"
                rel="noreferrer"
                className="btn-ghost text-xs"
                data-testid="baneoversigt-map-link"
              >
                <MapPin size={14} /> Åbn i kort
              </a>
            </div>
          </div>

          {PITCHES.map((p, i) => (
            <article
              key={p.id}
              data-testid={`pitch-card-${p.id}`}
              className="group relative hairline bg-neutral-950 p-5 transition-transform duration-200 hover:-translate-y-1 hover:border-brand lg:col-span-1"
            >
              <div className="flex items-start justify-between gap-2">
                <span className="mono-label text-neutral-500">
                  #{String(i + 1).padStart(2, "0")}
                </span>
                <span
                  className={`border px-2 py-[2px] text-[10px] font-mono uppercase tracking-widest ${statusClass(p.status)}`}
                >
                  {p.status}
                </span>
              </div>

              <h3 className="mt-4 font-heading text-xl uppercase tracking-tight text-white">
                {p.name}
              </h3>
              <p className="mt-2 font-body text-sm text-neutral-400">{p.usage}</p>

              <div className="mt-5 grid grid-cols-2 gap-3 border-t border-neutral-800 pt-4 text-xs">
                <div className="flex items-center gap-2 text-neutral-400">
                  <Ruler size={14} className="text-brand" />
                  <span className="font-mono">{p.size}</span>
                </div>
                <div className="flex items-center gap-2 text-neutral-400">
                  <span className="mono-label text-brand">▍</span>
                  <span className="font-mono">{p.surface}</span>
                </div>
                <div className="flex items-center gap-2 text-neutral-400">
                  <Lightbulb
                    size={14}
                    className={p.light ? "text-brand" : "text-neutral-600"}
                  />
                  <span className="font-mono">
                    {p.light ? "Lys" : "Ingen lys"}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
